import common from './front-common';
import pagesEntryInput01 from './pages/entry/input-step01';
import pagesEntryInput02 from './pages/entry/input-step02';
import pagesEntryConfirm from './pages/entry/confirm';
import '@/css/front.scss';

common();
pagesEntryInput01();
pagesEntryInput02();
pagesEntryConfirm();